var React = require('react');

function HeaderFbIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.95508 13.625H4.3418V7.81055H6.19531L6.5 5.5H4.3418V3.90039C4.3418 3.54492 4.39258 3.26562 4.54492 3.08789C4.69727 2.88477 5.02734 2.7832 5.48438 2.7832H6.70312V0.726562C6.24609 0.675781 5.63672 0.625 4.92578 0.625C4.01172 0.625 3.30078 0.904297 2.76758 1.4375C2.20898 1.9707 1.95508 2.70703 1.95508 3.67188V5.5H0V7.81055H1.95508V13.625Z","fill":"#414042"}));
}

HeaderFbIcon.defaultProps = {"width":"7","height":"14","viewBox":"0 0 7 14","fill":"none"};

module.exports = HeaderFbIcon;

HeaderFbIcon.default = HeaderFbIcon;
